"use client";
import React, { useState } from "react";
import ChatIcon from "@/assets/icons/chat.svg";
import { twMerge } from "tailwind-merge";
import DefaultProfile from "@/assets/graphics/default-profile.svg";
import Link from "next/link";
import useMe from "@/shared/hooks/useMe";
import { ImageTypeHandler } from "@/app/(components)/Basic/ImageTypeHandler";

export interface Props {
  onCommentPost: (id: string) => Promise<any>;
  iconsSize?: "small" | "big";
  className?: string;
  replyText?: string;
}

function CommentInput({
  onCommentPost,
  iconsSize = "small",
  className,
  replyText = "Post comment",
}: Props) {
  const { me } = useMe();
  const [comment, setComment] = useState<string>("");

  const onSubmit = async () => {
    await onCommentPost(comment);
    setComment("");
  };
  if (!me) {
    return (
      <Link
        href="/login"
        className="block text-body-2 text-green underline w-full text-center"
      >
        Log in to leave a comment
      </Link>
    );
  }

  const isEmptyComment: boolean = comment.trim().length == 0;

  return (
    <div
      className={twMerge(
        "border-b border-gray-100 night:border-opacityGray-100 endemic:border-[rgba(143,145,153,0.5)] py-5",
        className,
      )}
    >
      <div className="flex justify-between">
        <div className="flex items-start w-full">
          <div className="relative mr-2 w-10 h-10 flex-shrink-0">
            {me?.imageUrl ? (
              <ImageTypeHandler
                src={me?.imageUrl}
                placeholder={me.imagePlaceholder}
                alt={me?.fullName || "profile image"}
                className="rounded-full"
                fill
              />
            ) : (
              <DefaultProfile />
            )}
          </div>
          <div className="pl-2 w-full">
            <textarea
              className="max-h-[100px] rounded-3xl p-6 border-gray border-2 w-full resize-none text-body-3 leading-[22px] night:bg-primary endemic:bg-transparent placeholder:endemic:text-primary outline-none"
              rows={3}
              placeholder="Type your message here..."
              value={comment}
              onChange={(event) => setComment(event.target.value)}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="ml-16 text-red endemic:text-primary flex items-center py-2 text-body-4">
        <span
          onClick={() => !isEmptyComment && onSubmit()}
          className={twMerge(
            "flex mr-6 cursor-pointer items-center",
            isEmptyComment && "cursor-not-allowed text-secondary",
          )}
        >
          <ChatIcon
            className={twMerge(
              "fill-red mr-1",
              iconsSize === "small" && "w-4",
              iconsSize === "big" && "w-6",
              isEmptyComment ? "fill-secondary" : "endemic:fill-primary",
            )}
          />{" "}
          {replyText}
        </span>
      </div>
    </div>
  );
}

export default CommentInput;
